import React from 'react';
import { hero, crumbs, tabs } from '../../asiaListingData';
import { ChevronRight } from '../egypt/EgyptIcons';
import { StickyTabs } from '../egypt/EgyptHero';
import TrustBar from '../TrustBar';
import Header from '../Header';

const Photo = ({ img, className = '', eager }) => (
  <div className={`relative overflow-hidden bg-[#EAE8E0] ${className}`}>
    <img src={img.src} alt={img.alt} title={img.title} className="absolute inset-0 w-full h-full object-cover" loading={eager ? 'eager' : 'lazy'} data-testid="as-hero-image" />
  </div>
);

export default function AsiaHero() {
  const [a, b, c] = hero.images;
  return (
    <>
      <Header />
      <section className="w-full" data-testid="as-hero">
        <div className="grid gap-1 grid-cols-2 grid-rows-2 md:grid-cols-3 md:grid-rows-1 h-[300px] sm:h-[380px] md:h-[440px] lg:h-[520px] overflow-hidden" data-testid="as-hero-collage">
          <Photo img={a} className="row-span-2 md:row-span-1" eager />
          <Photo img={b} eager />
          <Photo img={c} eager />
        </div>
        <div className="bg-[#F6F4EB]" data-testid="as-hero-copy">
          <div className="w-full max-w-[1440px] mx-auto px-4 py-6 sm:px-8 md:px-10 md:py-8 flex flex-col md:flex-row md:items-center gap-6 md:gap-12 lg:gap-[100px]">
            <div className="flex-1">
              <h1 className="eg-display-lg text-[#002131] [text-wrap:balance]" data-testid="as-hero-title">{hero.h1}</h1>
            </div>
          </div>
        </div>
      </section>

      <div className="mt-6" data-testid="as-trust-bar"><TrustBar happy /></div>

      <StickyTabs tabs={tabs} testId="as" />

      <nav className="mt-8 w-full max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-[60px] flex items-center gap-1 eg-body-md text-[#174358]" aria-label="Breadcrumb" data-testid="as-breadcrumb">
        {crumbs.map((cr, i) => (
          <React.Fragment key={cr.label}>
            {i > 0 && <ChevronRight size={20} className="text-[#174358]" />}
            {cr.href ? <a href={cr.href} className="hover:underline">{cr.label}</a> : <span className="eg-label-lg text-[#002131]">{cr.label}</span>}
          </React.Fragment>
        ))}
      </nav>
    </>
  );
}
